import React, { FunctionComponent, useMemo } from 'react';

import { setHtml } from 'Modules/ui';
import { Box, Typography, TypographyProps, BoxProps } from 'Modules/ui3';

import { WithContentSize } from '../types';


/*
    BLOCK: list
    PARAMS: style: string ['ordered' | 'unordered'], items: string[]
    EXAMPLE:
    {
        "type" : "list",
        "data" : {
            "style" : "unordered",
            "items" : [
                "This is a block-styled editor",
                "Clean output data",
                "Simple and powerful API"
            ]
        }
    }
 */

type ListRenderProps = WithContentSize & {
    style: 'ordered' | 'unordered';
    items: string[];
};

interface PropsBySize {
    boxProps: BoxProps;
    typographyProps: TypographyProps<'span'>;
}

export const ListRenderer: FunctionComponent<ListRenderProps> = ({
    style,
    items,
    size,
}) => {
    const { boxProps, typographyProps } = useMemo<PropsBySize>(() => ({
        boxProps: {
            pl: {
                desktop: 8,
                mobile: 5,
            }[size],
            my: {
                desktop: '24px',
                mobile: '16px',
            }[size],
        },
        typographyProps: {
            fontSize: {
                desktop: '20px',
                mobile: '16px',
            }[size],
            lineHeight: {
                desktop: '1.5',
                mobile: '1.4',
            }[size],
        },
    }), [size]);

    return (
        <Box
            component={style === 'ordered' ? 'ol' : 'ul'}
            {...boxProps}
        >
            {items.map((item, index) => (
                <li key={index}>
                    <Typography
                        component='span'
                        fontWeight='400'
                        color='grayscale.shade95'
                        {...typographyProps}
                        {...setHtml(item)}
                    />
                </li>
            ))}
        </Box>
    );
};
